// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billVersionEntity from './entities/bill-version.json';
import billVersionMenu from '../pages/bill-version/menu.json';
import billVersionFullForm from '../pages/bill-version/forms/full.json';
import billVersionContextForm from '../pages/bill-version/forms/context.json';
import billVersionMiniForm from '../pages/bill-version/forms/mini.json';
import billVersionLookupForm from '../pages/bill-version/forms/lookup.json';
import billVersionTableView from '../pages/bill-version/views/table.json';
import billVersionCardsView from '../pages/bill-version/views/cards.json';
import billVersionCalendarView from '../pages/bill-version/views/calendar.json';
import billVersionDashboardView from '../pages/bill-version/views/dashboard.json';

/** Тип запису «Редакція законопроєкту» зі сторінками пакета: меню, форми та подання з pages/bill-version/. */
export const billVersionDefinition: IRecordTypeDefinition = {
  ...billVersionEntity,
  views: assembleViewSet({
      table: billVersionTableView,
      cards: billVersionCardsView,
      calendar: billVersionCalendarView,
      dashboard: billVersionDashboardView,
  }),
  form: billVersionFullForm,
  forms: { full: billVersionFullForm, context: billVersionContextForm, mini: billVersionMiniForm, lookup: billVersionLookupForm },
  menu: billVersionMenu,
} as IRecordTypeDefinition;
